import coloredLogosCO from './colored-logos';
import grayLogosCO from './gray-logos';
import whiteLogosCO from './white-logos';

const LogosCO = {
    colored: coloredLogosCO,
    gray: grayLogosCO,
    white: whiteLogosCO
};

export default LogosCO;
